export const SUCCESS_DATA = [
  {
    id: 1,
    count: '1830+',
    text: 'Project executed',
  },
  {
    id: 2,
    count: '834+',
    text: 'Satisfied customers',
  },
  {
    id: 3,
    count: '390',
    text: 'Data management',
  },
];
